// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fire-fighting-traning-edu-year-gubun-tr td {\n  text-align: center;\n  color: white !important;\n  font-size: 1rem !important;\n  font-weight: 600;\n}\n.fire-fighting-traning-edu-year-gubun-tr .text-align-right {\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
